var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRisk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.7113C9.1906 19.89 8.8094 19.89 8.5 19.7113L0.839744 15.2887C0.530344 15.11 0.339744 14.7799 0.339744 14.4227L0.339743 5.57735C0.339743 5.22009 0.530343 4.88996 0.839743 4.71133L8.5 0.288676C8.8094 0.110043 9.1906 0.110043 9.5 0.288676L17.1603 4.71132C17.4697 4.88996 17.6603 5.22009 17.6603 5.57735L17.6603 14.4226C17.6603 14.7799 17.4697 15.11 17.1603 15.2887L9.5 19.7113Z",
    fill: "#A90821"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/Risk.45099179.svg";
export { ForwardRef as ReactComponent };